/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import AccordionCard from '@tcp/core/src/components/common/molecules/AccordionCard/view/AccordionCard';
import PropTypes from 'prop-types';
import React, { useRef, useEffect, useState } from 'react';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { isMobileWeb, setSessionStorage, getIconPath } from '@tcp/core/src/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { handleShakeSaveAndContinueOnSpc, parseBoolean } from '@tcp/core/src/utils/utils.js';
import checkoutLabels from '@tcp/core/src/utils/labels/cnc/checkout.labels';
import {
  ACCORDION_REF,
  SECTION_MODE,
  SPC_SECTION,
} from '../../../container/SinglePageCheckout.constants';
import PickupExpanded from './PickupExpanded';
import PickupHeader from './PickupHeader';
import PickupLocation from './PickupLocation.view';
import PickupCollapsed from './PickupCollapsed';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import InputCheckbox from '../../../../../../common/atoms/InputCheckbox';
import styles from '../styles/Pickup.style';
import { setContactFormValuesInSS } from '../../ContactForm/ContactForm.util';
import { setShippingFormValuesInSS } from '../../../container/Shipping/Shipping.utils';
import { readCookie } from '../../../../../../../utils/cookie.util';

const HeaderComponent = (props) => {
  const {
    section,
    savedAddress,
    updateSectionState,
    handleEdit,
    handleCancel,
    pickUpContactPerson,
    pageCategory,
    isPlccIC,
    bossSwitchEnabled,
    onPickUpOpenClick,
  } = props;
  const checkoutPickupLabels = getLabelFromCopyOrFromTranslation('checkout.pickup', checkoutLabels);
  return isPlccIC ? (
    <div className="pickup-modal-title">
      <BodyCopy component="span" fontWeight="extrabold" fontSize="fs20" fontFamily="secondary">
        {renderLabel(checkoutPickupLabels.lbl_pickup_info_title, 'lbl_pickup_info_title')}
      </BodyCopy>
    </div>
  ) : (
    <PickupHeader
      section={section}
      savedAddress={savedAddress}
      updateSectionState={updateSectionState}
      handleEdit={handleEdit}
      handleCancel={handleCancel}
      pickUpContactPerson={pickUpContactPerson}
      pageCategory={pageCategory}
      isPlccIC={isPlccIC}
      bossSwitchEnabled={bossSwitchEnabled}
      onPickUpOpenClick={onPickUpOpenClick}
      {...props}
    />
  );
};

const smsSection = ({
  className,
  smsSubscriptionStatus,
  isSMSUpdatesSingleOptInEnabled,
  smsUpdates,
  isExpanded,
  handleChange,
  handleChangeWithApiCall,
  checkSMSCheckBoxState,
  smsSignUpLabels,
}) => {
  return (
    <div className={`${className} `}>
      <div className="sms-updates-wrapper">
        {!smsSubscriptionStatus || !isSMSUpdatesSingleOptInEnabled ? (
          <div className={`sms-updates-container ${smsUpdates?.sendOrderUpdate && 'elem-mb-XS_1'}`}>
            <BodyCopy
              component="div"
              fontSize={isMobileWeb() ? 'fs13' : 'fs14'}
              fontWeight="bold"
              fontFamily="secondary"
            >
              {getDynamicLabelValues('dynamic.global_d.lbl_smsSignup_orderUpdates')}
            </BodyCopy>
            <InputCheckbox
              execOnChangeByDefault={false}
              className="check-box"
              input={{
                onChange: isExpanded ? handleChange : handleChangeWithApiCall,
                value: checkSMSCheckBoxState,
              }}
            />
          </div>
        ) : (
          <div className="sms-subscription-confirmation">
            <Image
              className="success-sms-subscribed-icon elem-mr-SM"
              width={24}
              height={24}
              src={getIconPath('orders')}
              alt="success-sms-subscribed"
            />
            <BodyCopy
              component="div"
              fontSize={isMobileWeb() ? 'fs13' : 'fs14'}
              fontWeight="bold"
              fontFamily="secondary"
            >
              {getDynamicLabelValues('dynamic.checkout_d.lbl_order_updates_subscribed')}
            </BodyCopy>
          </div>
        )}

        {checkSMSCheckBoxState && !smsSubscriptionStatus && (
          <BodyCopy
            component="div"
            fontSize={isMobileWeb() ? 'fs10' : 'fs12'}
            fontFamily="secondary"
          >
            {smsSignUpLabels?.smsSignupText}
          </BodyCopy>
        )}
      </div>
    </div>
  );
};
const setPayloadForPickup = (emailAddressFromShipping, emailAddress, props) => {
  const { userEmail, savedEmail, emailFailSafe, venmoStatus, isLoginV2FlowEnabled } = props;
  let pickupPayload = '';
  if (isLoginV2FlowEnabled && (!savedEmail || emailFailSafe || venmoStatus)) {
    pickupPayload = { email: emailAddress || userEmail || emailAddressFromShipping };
    setContactFormValuesInSS({ emailAddress });
    if (!savedEmail) {
      setSessionStorage({ key: 'emailForFailSafe', value: true });
    }
  }
  return pickupPayload;
};

function Pickup(props) {
  const {
    section,
    updateSectionState,
    triggerFormSubmit,
    pickUpContactPerson,
    clickedOutsideShippingFlag,
    clickedOutsideShipping,
    isPlccIC,
    pageCategory,
    bossSwitchEnabled,
    onPickUpOpenClick,
    pickupReduxForm,
    orderTrackingEnhancementEnabled,
    className,
    contactPickupFormValuesFromSS,
    smsSignUpLabels,
    pickUpAlternatePerson,
    isHasPickUpAlternatePerson,
    isSMSUpdatesSingleOptInEnabled,
    smsPhoneCountryCode,
    setPhoneCountryAction,
  } = props;
  const { smsSignUp: smsUpdates } = contactPickupFormValuesFromSS || {};
  const [smsCheckBoxState, setSMSCheckBoxState] = useState(smsUpdates?.sendOrderUpdate);
  const { isExpanded, disabled } = section || {};

  const handleChange = async () => {
    await setSMSCheckBoxState(!smsCheckBoxState);
  };
  useEffect(() => {}, [smsUpdates?.sendOrderUpdate]);
  useEffect(() => {
    setSMSCheckBoxState(smsUpdates?.sendOrderUpdate);
  }, [isExpanded]);

  useEffect(() => {
    setPhoneCountryAction(pickUpContactPerson?.phoneCountryCode || '+1');
  }, [pickUpContactPerson?.phoneCountryCode]);

  const handleChangeWithApiCall = async () => {
    const checkBoxState = !smsUpdates?.sendOrderUpdate;
    await setSMSCheckBoxState(!smsCheckBoxState);
    const {
      updateStoreDetails,
      userEmail,
      userPhone,
      isLoginV2FlowEnabled,
      shippingContactInfo,
      smsUpdatesAPIOptimization,
      setSMSUpdatesAction,
      shipments,
    } = props;
    const smsInfo = checkBoxState;
    const { emailAddress: emailAddressFromShipping } = shippingContactInfo || {};
    const { phoneNumber, emailAddress } = pickUpContactPerson;
    const vibesSmsPhoneNo = smsInfo ? phoneNumber : '';
    let payload = {};
    const emailPayload = setPayloadForPickup(emailAddressFromShipping, emailAddress, props);
    if (isHasPickUpAlternatePerson) {
      payload = {
        firstName: pickUpContactPerson?.firstName,
        lastName: pickUpContactPerson?.lastName,
        phone: isLoginV2FlowEnabled ? pickUpContactPerson?.phoneNumber : userPhone,
        c_altName: pickUpAlternatePerson?.firstName
          ? `${pickUpAlternatePerson?.firstName} ${pickUpAlternatePerson?.lastName}`
          : '',
        c_altFirstName: pickUpAlternatePerson?.firstName,
        c_altLastName: pickUpAlternatePerson?.lastName,
        c_altEmail: pickUpAlternatePerson?.emailAddress,
        email: userEmail,
        c_vibesSmsPhoneNo: vibesSmsPhoneNo,
        phoneCountryCode: pickUpContactPerson?.phoneCountryCode,
      };
      if (isLoginV2FlowEnabled) {
        payload = {
          ...payload,
          smsSignUp: { sendOrderUpdate: smsInfo },
          ...emailPayload,
        };
      }
    } else {
      payload = {
        firstName: pickUpContactPerson?.firstName,
        lastName: pickUpContactPerson?.lastName,
        phone: isLoginV2FlowEnabled ? pickUpContactPerson?.phoneNumber : userPhone,
        email: userEmail || emailAddressFromShipping,
        c_vibesSmsPhoneNo: vibesSmsPhoneNo,
        phoneCountryCode: pickUpContactPerson?.phoneCountryCode,
      };
      if (isLoginV2FlowEnabled) {
        payload = {
          ...payload,
          smsSignUp: { sendOrderUpdate: smsInfo },
          ...emailPayload,
        };
      }
    }

    const optimizedPayload = shipments
      ?.filter(
        (item) =>
          item.itemsCount > 0 &&
          (!item.shippingAddress.c_phoneCountryCode ||
            item.shippingAddress.c_phoneCountryCode === '+1')
      )
      ?.map((item) => ({
        shipmentId: item.shipmentId,
        c_vibesSmsPhoneNo: checkBoxState ? item?.shippingAddress?.phone?.replace(/\D/g, '') : '',
      }));
    if (smsUpdatesAPIOptimization) {
      setSMSUpdatesAction(optimizedPayload);
    } else {
      updateStoreDetails({ ...payload, isUpdating: true });
    }
    if (isLoginV2FlowEnabled) {
      setShippingFormValuesInSS({ smsSignUp: { sendOrderUpdate: smsInfo }, phoneNumber });
      updateSectionState({
        id: SPC_SECTION.SHIPPING,
        section: { smsSignUp: { sendOrderUpdate: smsInfo }, phoneNumber },
      });
    }
  };

  const handleEdit = () => {
    updateSectionState({ isExpanded: true, mode: SECTION_MODE.SECTION_EDIT_MODE });
  };
  const handleCancel = () => {
    updateSectionState({ isExpanded: false, mode: SECTION_MODE.SECTION_VIEW_MODE });
    setPhoneCountryAction(pickUpContactPerson.phoneCountryCode);
  };
  const pickupHeader = HeaderComponent({
    section,
    updateSectionState,
    handleEdit,
    pickUpContactPerson,
    handleCancel,
    pageCategory,
    isPlccIC,
    bossSwitchEnabled,
    onPickUpOpenClick,
    ...props,
  });
  const requestModalClose = () => {
    updateSectionState({ isExpanded: false, mode: SECTION_MODE.SECTION_VIEW_MODE });
  };

  const ref = useRef();

  const handleClickOutside = () => {
    handleShakeSaveAndContinueOnSpc(clickedOutsideShipping, true);
  };

  useEffect(() => {
    if (pickupReduxForm?.submitFailed) {
      handleClickOutside();
    }
  }, [pickupReduxForm?.submitFailed]);
  useEffect(() => {}, [smsUpdates]);
  const handleSave = () => {
    triggerFormSubmit();
  };
  const checkSMSCheckBoxState = isExpanded ? smsCheckBoxState : smsUpdates?.sendOrderUpdate;

  const smsPhoneCountryCodeValue =
    smsPhoneCountryCode || pickUpContactPerson?.phoneCountryCode || '+1';
  const showSMSCheckBoxCont = smsPhoneCountryCodeValue === '+1';

  const smsSubscriptionStatus = parseBoolean(readCookie('smsSubscriptionStatus')) || false;

  return (
    <>
      <AccordionCard
        header={pickupHeader}
        cardClassName="pickup-accordion"
        isExpanded={isExpanded}
        ref={ref}
        isActive={isExpanded}
        accordionCardRefId={ACCORDION_REF.PICKUP_REF_ID}
        bossSwitchEnabled={bossSwitchEnabled}
      >
        <PickupLocation />
        {isExpanded || isPlccIC || (bossSwitchEnabled && !pickUpContactPerson?.firstName) ? (
          <PickupExpanded
            {...props}
            isExpanded={isExpanded}
            handleSave={handleSave}
            requestModalClose={requestModalClose}
            isShake={clickedOutsideShippingFlag}
            isPlccIC={isPlccIC}
            smsCheckBoxState={smsCheckBoxState}
          />
        ) : (
          <PickupCollapsed {...props} />
        )}
        {orderTrackingEnhancementEnabled &&
          !disabled &&
          showSMSCheckBoxCont &&
          smsSection({
            className,
            smsSubscriptionStatus,
            isSMSUpdatesSingleOptInEnabled,
            smsUpdates,
            isExpanded,
            handleChange,
            handleChangeWithApiCall,
            checkSMSCheckBoxState,
            smsSignUpLabels,
          })}
      </AccordionCard>
    </>
  );
}

Pickup.propTypes = {
  formName: PropTypes.string.isRequired,
  section: PropTypes.shape({ isExpanded: false }).isRequired,
  triggerFormSubmit: PropTypes.func.isRequired,
  updateSectionState: PropTypes.func.isRequired,
  pickUpContactPerson: PropTypes.shape({}).isRequired,
  clickedOutsideShippingFlag: PropTypes.bool,
};

HeaderComponent.propTypes = {
  section: PropTypes.shape({ isExpanded: false }).isRequired,
  updateSectionState: PropTypes.func.isRequired,
  savedAddress: PropTypes.shape({}),
  getPickupFormData: PropTypes.shape({}).isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  pickUpContactPerson: PropTypes.shape({}).isRequired,
};
HeaderComponent.defaultProps = {
  savedAddress: {},
};

export default withStyles(Pickup, styles);
